import React, { useEffect, useState, useCallback, useMemo } from 'react';
import './index.css';
import { DashBoardTitle } from '../../Title';
import { Col, Container, Row, Table } from 'reactstrap';
import { getDealerwithStatus } from '../../../constants/apiCalls';
import Pagination from '../../Pagination/Pagination';
import CustomSpinner from '../../CustomSpinner/CustomSpinner';
import { BreadCrumbBackButton } from '../../Breadcrumbs/BreadCrumbBackButton';
import { Breadcrumbs } from '../../Breadcrumbs/Breadcrumbs';
import Storage from '../../../services/Storage';
import { UserFilters } from '../../Filters';
import ModalService from '../../../services/ModalService';
import { handleErrorMessage } from '../../../utils/utils';
import DateService from '../../../services/DateService';
import { messages } from '../../../utils/constant-messages';
import remarkIcon from '../../../images/remark.png';
import { useNavigate } from 'react-router-dom';
import { Permissions } from '../../../constants/Permissions';
import { Roles } from '../../../constants/Roles';
import { useSelector } from 'react-redux';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

export function RejectedAppTable() {

  const navigate = useNavigate();
  // const localPermission = Storage.getUserPermissionDetail();

  const { permissionArr } = useSelector(state => state.UserGetReducer)
  const localPermission = permissionArr;

  let userInfo = Storage.getUserInfoDetail();
  let roleName = userInfo ? userInfo.role : '';

  useEffect(() => {
    if (!localPermission.includes(Permissions.REJECTED_APP)) {
      navigate('/');
    }
  }, [...localPermission])

  let pageNo = useMemo(() => Storage.getRejectPage(), [Storage.getRejectPage()]);

  const [isLoading, setIsloading] = useState(false);
  const [dealerData, setDealerData] = useState([]);
  const [count, setCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(Number(pageNo) ? Number(pageNo) : 1);
  const [pageSize, setPageSize] = useState(10);
  const [object, setObject] = useState('');

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  let userDataAll = Storage.getBreadcrumbsrRecord();
  let userData = useMemo(
    () =>
      userDataAll.reduce((unique, o) => {
        if (!unique.some((obj) => obj.id === o.id && obj.role === o.role)) {
          if (o.filter) {
            unique.push(o.filter);
          }
        }
        return unique;
      }, []),
    []
  );

  useEffect(() => { }, [userData]);

  const getDealerData = useCallback(
    (obj, page, pageSize) => {
      setIsloading(true);
      setObject(obj);
      let payload = {
        q: obj.searchQuery || '',
        pagesize: pageSize,
        page: page || 1,
        type: 'reject',
        pipeline_status: obj.statusId || null,
        start_date: obj.startDate ? obj.startDate : '',
        end_date: obj.endDate ? obj.endDate : '',
        nh: obj.nhId || null,
        sh: obj.shId || null,
        th: obj.tmId || null,
        state_id: obj.stateId || null,
        territory_id: obj.territoryId || null,
        adminOnly: false,
        manageDealer: false,
        application_upload: false,
        is_download: false,
      };
      getDealerwithStatus((res) => {
        const { data, success, error } = res;
        if (success === true) {
          setDealerData(data.data);
          let count = data.total_count;
          setCount(count);
          let totalPages = Math.ceil(count / pageSize);
          setTotalPages(totalPages);
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setIsloading(false);
      }, payload);
    },
    [object, page, pageSize]
  );

  const handleExcelSheet = useCallback(
    (obj, page, pageSize) => {
      let payload = {
        q: obj.searchQuery || '',
        pagesize: 100000,
        page: page || 1,
        type: 'reject',
        pipeline_status: obj.statusId || null,
        start_date: obj.startDate ? obj.startDate : '',
        end_date: obj.endDate ? obj.endDate : '',
        nh: obj.nhId || null,
        sh: obj.shId || null,
        th: obj.tmId || null,
        state_id: obj.stateId || null,
        territory_id: obj.territoryId || null,
        adminOnly: false,
        manageDealer: false,
        application_upload: false,
        is_download: true,
      };
      getDealerwithStatus((res) => {
        const { data, success, error } = res;
        if (success === true) {
          window.open(data.file, '_blank');
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setIsloading(false);
      }, payload);
    },
    [object, page, pageSize]
  );

  const handlePageChange = useCallback(
    (page) => {
      setPage(page);
      Storage.setRejectPage(Number(page));
      getDealerData(object, page, pageSize);
    },
    [object, page, pageSize]
  );

  const handleInputChange = useCallback(
    (e) => {
      let pageSize = parseInt(e.target.value);
      setPageSize(pageSize);
      setPage(1);
      getDealerData(object, page, pageSize);
    },
    [object, page, pageSize]
  );

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id='rejectedTable'>
              {isLoading && <CustomSpinner />}

              <div className='pageWrapper'>
                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className='pageheader'>
                        <DashBoardTitle dashBorardName='Rejected Application' />
                        <BreadCrumbBackButton />
                      </div>
                    </Col>
                    <Col xs={12}>
                      <Breadcrumbs title='Rejected Application' />
                    </Col>
                    <Col xs={12}>
                      <UserFilters
                        page={page}
                        setPage={setPage}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        pageNo={pageNo}
                        userData={userData}
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                        dealerData={getDealerData}
                        excelData={handleExcelSheet}
                      />
                    </Col>
                  </Row>
                  {dealerData.length && count > 0 ? (
                    <Row>
                      <Col xs={12}>
                        <div className='table-responsive dealerTable'>
                          <Table bordered className='table text-center'>
                            <thead>
                              <tr>
                                <th>Application Date</th>
                                <th>Rejected Date</th>
                                <th>Form Number</th>
                                <th>Business Name</th>
                                <th>Owner Name</th>
                                <th>Mobile</th>
                                <th>City/Town</th>
                                {roleName === Roles.BH_NAME && <th>NH</th>}
                                {(roleName === Roles.NH_NAME ||
                                  roleName === Roles.BH_NAME) && <th>SH</th>}
                                <th>TM</th>
                                {roleName !== Roles.TM_NAME && <th>State</th>}
                                <th>Territory</th>
                                <th>Status</th>
                                <th>Remarks</th>
                              </tr>
                            </thead>
                            <tbody>
                              {dealerData.map((elem, index) => {
                                const {
                                  application_date,
                                  rejected_date,
                                  id,
                                  business_name,
                                  primary_contact_name,
                                  primary_contact_mobile,
                                  city,
                                  territory,
                                  nh,
                                  sh,
                                  th,
                                  state,
                                  status,
                                  remark,
                                } = elem;
                                return (
                                  <tr key={index}>
                                    <td>
                                      {DateService.localDateOnly(application_date) || 'N/A'}
                                    </td>
                                    <td>
                                      {DateService.localDateOnly(rejected_date) || 'N/A'}
                                    </td>
                                    <td>{id}</td>
                                    <td>
                                      <span>{business_name}</span>
                                    </td>
                                    <td>{primary_contact_name}</td>
                                    <td>{primary_contact_mobile}</td>
                                    <td>{city}</td>
                                    {roleName === Roles.BH_NAME && <td>{nh}</td>}
                                    {(roleName === Roles.NH_NAME ||
                                      roleName === Roles.BH_NAME) && <td>{sh}</td>}
                                    <td>{th}</td>
                                    {roleName !== Roles.TM_NAME && <td>{state}</td>}
                                    <td>{territory}</td>
                                    <td>{status}</td>
                                    <td>
                                      {/* {remark} */}
                                      <div className='actionBlock'>
                                        <img
                                          src={remarkIcon}
                                          alt='actionImg'
                                          className='actionIconImg'
                                        />
                                        <div className='remarkTooltip commonTooltip'>
                                          <div>{remark || 'N/A'}</div>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                      <Col xs={12}>
                        <div className='paginationWrapper'>
                          <span className='page-select-title'>Rows per page:</span>
                          &nbsp;&nbsp;
                          <select
                            className='form-control rows-per-page-select'
                            name='pageSize'
                            value={pageSize}
                            onChange={(e) => handleInputChange(e)}
                          >
                            <option key='5' value='5'>
                              5 Rows
                            </option>
                            <option key='10' value='10'>
                              10 Rows
                            </option>
                            <option key='15' value='15'>
                              15 Rows
                            </option>
                            <option key='20' value='25'>
                              25 Rows
                            </option>
                            <option key='25' value='30'>
                              30 Rows
                            </option>
                            <option key='30' value='50'>
                              50 Rows
                            </option>
                          </select>
                          &nbsp;&nbsp;
                          <div className='pageList'>
                            <Pagination
                              margin={2}
                              page={page}
                              count={parseInt(totalPages)}
                              pageSize={pageSize}
                              totalRecords={parseInt(count)}
                              onPageChange={handlePageChange}
                            ></Pagination>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col xs={12}>
                        {messages.COMMON.NO_RECORD_MATCH}
                      </Col>
                    </Row>
                  )}
                </Container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
